import { render, staticRenderFns } from "./ProductConfigurator.vue?vue&type=template&id=5049b310&"
import script from "./ProductConfigurator.vue?vue&type=script&lang=js&"
export * from "./ProductConfigurator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports